import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { StepProcessorProvider, Step } from '../../context/StepProcessorContext';
import AuthStepProcessor from './AuthStepProcessor';
import EmailStep from './EmailStep';
import OtpStep from './OtpStep';
import { isAuthenticated } from '../../services/AuthService';

const Auth: React.FC = () => {
  const navigate = useNavigate();

  // Define the steps for authentication
  const authSteps: Step[] = [
    {
      id: 'email',
      name: 'Email',
      isCompleted: false,
      isActive: true,
      component: <EmailStep />
    },
    {
      id: 'otp',
      name: 'OTP Verification',
      isCompleted: false,
      isActive: false,
      component: <OtpStep />
    }
  ];

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/homepage');
    }
  }, [navigate]);

  return (
    <motion.div
      initial={{ x: '100%' }}
      animate={{ x: 0 }}
      exit={{ x: '-100%', transition: { duration: 0.1 } }}
      className="flex flex-col h-full"
    >
      <StepProcessorProvider initialSteps={authSteps}>
        <AuthStepProcessor />
      </StepProcessorProvider>
    </motion.div>
  );
};

export default Auth;
